import type { LegalContent } from './types';

export const legalPtBR: LegalContent = {
  terms: {
    title: 'Termos de Uso',
    version: 'Versão 1.0',
    effectiveDate: 'Data de vigência: 2026-08-18',
    draftNotice: 'Este documento é uma versão preliminar e deve ser revisado por um advogado antes da publicação oficial.',
    sections: [
      {
        heading: '1. Objeto',
        paragraphs: [
          'Estes Termos de Uso ("Termos") regulam a utilização da plataforma Aura Nota ("Serviço"), um software de captura e extração automatizada de campos de documentos fiscais brasileiros (NFS-e, NF-e, faturas de telecomunicações e similares), fornecido pela Felixtal, inscrita no CNPJ sob o nº 07.888.306/0001-75 ("Aura Nota", "nós", "nosso").',
          'O Serviço realiza o processamento de arquivos (PDF, XML, imagens e e-mails) para extrair dados estruturados por meio de OCR, parsing de XML e modelos de linguagem, com capacidade de auto-aprendizado a partir de correções humanas.',
        ],
      },
      {
        heading: '2. Cadastro e conta',
        paragraphs: [
          'O acesso ao Serviço exige a criação de uma conta com e-mail e senha. O usuário é responsável pela exatidão dos dados fornecidos no cadastro e pela manutenção da confidencialidade de suas credenciais. Qualquer atividade realizada com a conta do usuário é considerada de sua responsabilidade.',
        ],
      },
      {
        heading: '3. Obrigações do usuário',
        list: [
          'Fornecer informações verdadeiras e atualizadas no cadastro.',
          'Manter a confidencialidade de suas credenciais de acesso.',
          'Utilizar o Serviço em conformidade com a legislação brasileira, incluindo a LGPD (Lei 13.709/2018).',
          'Não enviar documentos cujo processamento viole direitos de terceiros.',
          'Não tentar comprometer a segurança, integridade ou disponibilidade do Serviço.',
          'Revisar os dados extraídos antes de utilizá-los para fins fiscais ou contábeis, pois a extração automatizada pode conter erros.',
        ],
      },
      {
        heading: '4. Obrigações do Aura Nota',
        list: [
          'Disponibilizar o Serviço com razoável disponibilidade e continuidade.',
          'Adotar medidas técnicas e organizacionais de segurança conforme descrito na Política de Privacidade.',
          'Tratar os dados pessoais em conformidade com a LGPD.',
          'Manter registro de consentimento dos usuários (Art. 8 da LGPD).',
          'Oferecer canal de contato para dúvidas e exercício de direitos (web@felixtal.com).',
        ],
      },
      {
        heading: '5. Dados pessoais',
        paragraphs: [
          'O tratamento de dados pessoais no Serviço é regido pela Política de Privacidade, disponível em /privacy. Ao aceitar estes Termos, o usuário declara estar ciente das finalidades, bases legais e medidas de segurança descritas naquele documento.',
        ],
      },
      {
        heading: '6. Limitação de responsabilidade',
        paragraphs: [
          'O Serviço é fornecido "no estado em que se encontra". A extração automatizada de campos pode conter imprecisões; é responsabilidade do usuário revisar os resultados antes de qualquer uso fiscal, contábil ou legal. O Aura Nota não se responsabiliza por decisões tomadas com base em dados extraídos sem revisão humana.',
          'Em nenhuma hipótese o Aura Nota será responsável por danos indiretos, lucros cessantes ou perda de dados decorrentes do uso ou impossibilidade de uso do Serviço, nos limites permitidos pela legislação brasileira.',
        ],
      },
      {
        heading: '7. Suspensão e encerramento de conta',
        paragraphs: [
          'O Aura Nota poderá suspender ou encerrar contas que violem estes Termos ou que apresentem risco à segurança do Serviço. O usuário poderá solicitar o encerramento de sua conta a qualquer momento via web@felixtal.com.',
        ],
      },
      {
        heading: '8. Modificações dos Termos',
        paragraphs: [
          'Estes Termos poderão ser atualizados periodicamente. Alterações materiais serão comunicadas aos usuários, que poderão ser solicitados a prestar novo consentimento. A versão vigente é sempre a disponível nesta página, com a data de vigência indicada.',
        ],
      },
      {
        heading: '9. Lei aplicável',
        paragraphs: [
          'Estes Termos são regidos pelas leis da República Federativa do Brasil, inclusive a Lei Geral de Proteção de Dados (LGPD, Lei 13.709/2018). Fica eleito o foro da Comarca do domicílio do usuário para dirimir quaisquer controvérsias.',
        ],
      },
      {
        heading: '10. Contato',
        paragraphs: [
          'Para questões relacionadas a estes Termos, privacidade ou exercício de direitos sob a LGPD, entre em contato pelo e-mail web@felixtal.com.',
        ],
      },
    ],
  },
  privacy: {
    title: 'Política de Privacidade',
    version: 'Versão 1.2',
    effectiveDate: 'Data de vigência: 2026-10-08',
    draftNotice: 'Este documento é uma versão preliminar e deve ser revisado por um advogado antes da publicação oficial.',
    sections: [
      {
        heading: '1. Introdução',
        paragraphs: [
          'Esta Política de Privacidade descreve como o Aura Nota ("nós") trata os dados pessoais coletados por meio de sua plataforma de captura e extração de documentos fiscais, em conformidade com a Lei Geral de Proteção de Dados (LGPD, Lei 13.709/2018).',
        ],
      },
      {
        heading: '2. Dados coletados',
        paragraphs: [
          'O Serviço processa documentos fiscais enviados pelos usuários, dos quais são extraídos, entre outros, os seguintes dados pessoais:',
        ],
        list: [
          'CNPJ e CPF de emitentes e destinatários;',
          'Nomes ou razões sociais;',
          'Endereços;',
          'Valores financeiros (totais, impostos, unitários);',
          'Datas de emissão e competência;',
          'Demais campos presentes em NFS-e, NF-e e faturas de telecomunicações.',
        ],
      },
      {
        heading: '3. Finalidade do tratamento',
        paragraphs: [
          'Os dados são tratados com a finalidade de extração automatizada de campos de documentos fiscais, organização e exportação dos dados extraídos, e auto-aprendizado: correções humanas alimentam o aprimoramento dos modelos de extração, melhorando a acurácia futura.',
        ],
      },
      {
        heading: '4. Base legal',
        paragraphs: [
          'O Aura Nota atua em dois papéis: (a) controladora dos dados de cadastro, acesso, logs e cobrança — tratados sob execução de contrato (Art. 7, inciso V, da LGPD), legítimo interesse (Art. 7, inciso IX — segurança e prevenção a fraudes) e obrigação legal (Art. 7, inciso II); (b) operadora do conteúdo dos documentos fiscais enviados pelas organizações, tratado exclusivamente conforme as instruções da organização controladora (Arts. 39 a 42 da LGPD).',
          'O consentimento do usuário é registrado para os Termos de Uso, esta Política e a Política de Cookies (Art. 8 da LGPD); o aceite do Termo de Custódia é registrado separadamente, com identificação do usuário, data, hora e versão do documento.',
        ],
      },
      {
        heading: '5. Compartilhamento de dados',
        paragraphs: [
          'Não compartilhamos dados pessoais com terceiros, exceto parceiros de infraestrutura essenciais à operação e quando exigido por obrigação legal ou ordem judicial. Os dados não são vendidos nem cedidos para fins de marketing.',
          'Os suboperadores de infraestrutura atualmente utilizados são: (i) Contabo GmbH — hospedagem do servidor VPS na França (União Europeia; datacenter em Lauterbourg operado pela subprocessadora Contabo France SAS), onde ficam armazenados todos os dados do Serviço, sob contrato de tratamento de dados (DPA); (ii) Cloudflare, Inc. — serve os arquivos estáticos públicos do frontend (Cloudflare Pages) e responde DNS; atua como operadora pass-through, transmitindo requisições e respostas apenas em trânsito, sem armazenar conteúdo, sob DPA incorporado ao contrato com Cláusulas Contratuais Padrão (SCCs) e certificação no EU-US Data Privacy Framework.',
        ],
      },
      {
        heading: '6. Transferência internacional',
        paragraphs: [
          'A infraestrutura do Serviço (servidor VPS da Contabo GmbH) está localizada na França, na União Europeia, jurisdição com nível de proteção reconhecidamente adequado, e é onde todos os dados pessoais ficam hospedados. A Cloudflare serve apenas os arquivos estáticos públicos do frontend (Cloudflare Pages) e respostas de DNS, atuando como operadora pass-through: requisições e respostas trafegam pela rede da Cloudflare em trânsito, sem armazenamento de conteúdo. A transferência internacional de dados pessoais é realizada com garantias adequadas, mediante contrato de tratamento de dados (DPA), Cláusulas Contratuais Padrão (SCC) e, no caso da Cloudflare, certificação no EU-US Data Privacy Framework, em conformidade com o Art. 33 da LGPD e o Regulamento de Transferência Internacional da ANPD (Resolução CD/ANPD nº 19/2024).',
        ],
      },
      {
        heading: '7. Retenção',
        paragraphs: ['Os prazos de retenção são os seguintes:'],
        list: [
          'Falhas de processamento: 24 horas para diagnóstico;',
          'Corpus de auto-aprendizado: 90 dias;',
          'Backups: 7 dias.',
        ],
      },
      {
        heading: '8. Segurança',
        paragraphs: ['Adotamos as seguintes medidas técnicas e organizacionais de segurança:'],
        list: [
          'Autenticação por JWT (JSON Web Token);',
          'Criptografia de dados em trânsito (TLS) e em repouso;',
          'AIDE (Advanced Intrusion Detection Environment) para integridade;',
          'Permissões de arquivo restritas e princípio do menor privilégio;',
          'Execução do Serviço com usuário não-root.',
        ],
      },
      {
        heading: '9. Anonimização',
        paragraphs: [
          'Antes do armazenamento prolongado, dados pessoais identificáveis (PII) são mascarados. O identificador de documento (doc_id) é armazenado em forma de hash, de modo que o dado original não possa ser reconstruído a partir do registro persistido.',
        ],
      },
      {
        heading: '10. Direitos do titular',
        paragraphs: ['Conforme os Arts. 17 a 22 da LGPD, o titular dos dados possui os seguintes direitos:'],
        list: [
          'Confirmação da existência de tratamento e acesso aos dados;',
          'Retificação de dados incompletos, inexatos ou desatualizados;',
          'Eliminação de dados pessoais tratados com consentimento;',
          'Direito ao esquecimento (portabilidade e eliminação);',
          'Informação sobre compartilhamento e finalidade.',
        ],
      },
      {
        heading: '11. Encarregado (DPO)',
        paragraphs: [
          'O Encarregado de Proteção de Dados da Felixtal (CNPJ 07.888.306/0001-75) pode ser contatado pelo e-mail web@felixtal.com.',
        ],
      },
      {
        heading: '12. Avaliação de impacto (DPIA)',
        paragraphs: [
          'Uma Avaliação de Impacto sobre a Proteção de Dados Pessoais (DPIA) foi elaborada e está disponível mediante solicitação ao DPO. O documento descreve os riscos e as medidas mitigadoras adotadas para o tratamento de dados fiscais sensíveis.',
        ],
      },
      {
        heading: '13. Cookies',
        paragraphs: [
          'O uso de cookies é descrito em detalhe na Política de Cookies, disponível em /cookies.',
        ],
      },
      {
        heading: '14. Alterações desta política',
        paragraphs: [
          'Esta Política poderá ser atualizada periodicamente. Alterações materiais serão comunicadas e poderão exigir novo consentimento. A versão vigente é sempre a disponível nesta página, com a data de vigência indicada.',
        ],
      },
    ],
  },
  cookies: {
    title: 'Política de Cookies',
    version: 'Versão 1.0',
    effectiveDate: 'Data de vigência: 2026-08-18',
    draftNotice: 'Este documento é uma versão preliminar e deve ser revisado por um advogado antes da publicação oficial.',
    sections: [
      {
        heading: '1. O que são cookies',
        paragraphs: [
          'Cookies são pequenos arquivos de texto armazenados no navegador do usuário para manter informações de sessão e preferências entre requisições. Eles são necessários para o funcionamento básico de aplicações web autenticadas.',
        ],
      },
      {
        heading: '2. Cookies utilizados',
        paragraphs: ['O Aura Nota utiliza apenas cookies essenciais ao funcionamento do Serviço:'],
        list: [
          'Session JWT / auth token: mantém a sessão autenticada do usuário após o login. Sem este cookie, não é possível acessar as funcionalidades que exigem autenticação.',
        ],
      },
      {
        heading: '3. Cookies de terceiros',
        paragraphs: [
          'O Aura Nota não utiliza cookies de terceiros. Não utilizamos ferramentas de análise, rastreamento ou publicidade de terceiros que armazenem cookies no seu navegador.',
        ],
      },
      {
        heading: '4. Gerenciamento de cookies',
        paragraphs: [
          'Você pode desativar ou remover cookies a qualquer momento por meio das configurações do seu navegador. Vale ressaltar que a desativação do cookie de sessão impedirá o acesso às funcionalidades autenticadas do Serviço.',
        ],
      },
      {
        heading: '5. Atualizações',
        paragraphs: [
          'Esta Política de Cookies poderá ser atualizada caso o Serviço passe a utilizar novos cookies. Alterações serão comunicadas nesta página, com a data de vigência indicada.',
        ],
      },
      {
        heading: '6. Contato do DPO',
        paragraphs: [
          'Para dúvidas sobre esta política de cookies ou seus direitos de privacidade, entre em contato com nosso Encarregado de Dados (DPO): web@felixtal.com.',
        ],
      },
    ],
  },
  custodia: {
    title: 'Termo de Custódia de Certificado Digital A1',
    version: 'Versão 1.0',
    effectiveDate: 'Data de vigência: 2026-09-16',
    draftNotice: 'Este documento é uma versão preliminar e deve ser revisado por um advogado antes da publicação oficial.',
    sections: [
      {
        heading: '1. Objeto e aceite dedicado',
        paragraphs: [
          'Este Termo regula a custódia, pela plataforma Aura Nota, do certificado digital A1 (e-CNPJ) da sua organização, necessário para consultas autenticadas aos portais da SEFAZ/RFB (consulta por chave de acesso e distribuição de documentos fiscais eletrônicos).',
          'Este aceite é autônomo e adicional aos Termos de Uso e à Política de Privacidade. A custódia somente ocorre após a marcação expressa deste termo por um administrador ou proprietário da organização.',
          'O aceite eletrônico deste Termo é registrado com identificação do usuário, data, hora e versão do documento, constituindo manifestação válida de vontade e prova do consentimento (Art. 8 da LGPD; Art. 10, §2º, da MP 2.200-2/2001).',
        ],
      },
      {
        heading: '2. O que é custodiado',
        paragraphs: [
          'O arquivo do certificado (.pfx/.p12) e a senha correspondente, ambos cifrados em repouso com criptografia forte e chave dedicada, mantidos em banco de dados da plataforma.',
          'O material do certificado nunca é exibido, exportado ou retornado em qualquer resposta da plataforma após o envio.',
        ],
      },
      {
        heading: '3. Como o certificado é utilizado',
        paragraphs: [
          'O certificado é utilizado exclusivamente para abrir sessões efêmeras no serviço de integração fiscal, que o mantém apenas em memória durante a sessão e o descarta ao final — sem persistência.',
          'As sessões autenticam consultas à SEFAZ/RFB em nome da organização titular do certificado. Nenhum outro uso é realizado.',
          'O certificado custodiado não é utilizado para assinar documentos ou eventos fiscais — incluindo NF-e, CT-e, NFS-e, manifestação do destinatário e cartas de correção — nem para qualquer ato que exija assinatura digital. Seu uso restringe-se à autenticação de sessão para consultas junto à SEFAZ/RFB.',
        ],
      },
      {
        heading: '4. Papéis na LGPD',
        paragraphs: [
          'A organização titular do certificado é a controladora da credencial. O Aura Nota atua como operador, tratando o material exclusivamente conforme este Termo, por meio do serviço de integração fiscal — componente interno da plataforma que acessa o material apenas em memória e de forma transitória.',
        ],
      },
      {
        heading: '5. Segurança e controle de acesso',
        list: [
          'Somente administradores e proprietários da organização podem enviar, rotacionar ou remover o certificado.',
          'Todas as ações sobre o certificado são registradas em trilha de auditoria (quem, quando, o quê), e consentimentos são registrados com data e IP.',
          'O envio é limitado por cotas de taxa e validado antes da custódia.',
          'Alertas de vencimento são emitidos 30, 15 e 7 dias antes da expiração.',
          'O CNPJ do titular do certificado é validado contra o CNPJ da organização antes da custódia; divergência bloqueia o envio.',
        ],
      },
      {
        heading: '6. Responsabilidades e limites',
        list: [
          'A organização declara que o usuário que realiza o aceite possui poderes para vinculá-la, que o certificado foi emitido por Autoridade Certificadora ICP-Brasil em nome de seu CNPJ e que seu envio é devidamente autorizado;',
          'A gestão do ciclo de vida do certificado — incluindo renovação e revogação junto à Autoridade Certificadora — é de responsabilidade exclusiva da organização;',
          'As consultas autenticadas realizadas com o certificado constituem atos da organização perante a SEFAZ/RFB; o Aura Nota não se responsabiliza por indisponibilidade, recusa ou limitações dos serviços da SEFAZ/RFB — incluindo janelas de distribuição de documentos — nem por prazos e obrigações fiscais da organização.',
        ],
      },
      {
        heading: '7. Incidentes de segurança',
        paragraphs: [
          'Em caso de incidente de segurança que possa comprometer o material custodiado, o Aura Nota notificará a organização sem demora injustificada, informando a natureza do incidente e as medidas recomendadas — incluindo a revogação do certificado junto à Autoridade Certificadora, de responsabilidade da organização. A comunicação à ANPD e a titulares de dados ocorrerá quando exigida pelo Art. 48 da LGPD.',
        ],
      },
      {
        heading: '8. Revogação e remoção',
        paragraphs: [
          'A organização pode remover o certificado a qualquer momento. A remoção apaga o material cifrado de forma irreversível, preservando apenas metadados e a trilha de auditoria, e encerra imediatamente a capacidade de consultas autenticadas.',
          'No encerramento da conta ou da relação contratual, o certificado será removido automaticamente, com os mesmos efeitos desta seção, mediante notificação prévia à organização.',
        ],
      },
      {
        heading: '9. Vigência',
        paragraphs: [
          'Este Termo vigora enquanto houver certificado custodiado; a versão vigente é registrada a cada aceite e alterações materiais exigem novo aceite. A remoção do certificado encerra a custódia, preservando metadados e trilha de auditoria pelo prazo de 5 (cinco) anos ou pelo prazo legal aplicável, o que for maior.',
        ],
      },
    ],
  },
};
